import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useStyle } from "../../../runtimes/react/use-style";
import { Warning20 } from "../../icons/Warning20";
const FallbackComponent = forwardRef(function FallbackComponent2({ text }, ref) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref,
      className: useStyle({
        width: "100%",
        height: 54,
        backgroundColor: "#fcedf2",
        borderRadius: 6,
        padding: 16,
        display: "flex",
        alignItems: "center",
        gap: 8,
        color: "#c73e6d",
        fill: "currentColor",
        fontFamily: "Heebo, sans-serif",
        fontSize: 16
      }),
      children: [
        /* @__PURE__ */ jsx(Warning20, {}),
        /* @__PURE__ */ jsx("span", { children: text })
      ]
    }
  );
});
export {
  FallbackComponent
};
//# sourceMappingURL=FallbackComponent.js.map